import { flow, size } from 'lodash/fp';
import getItemsWithPurchaseOptionIn from '../../../helpers/mandi/getItemsWithPurchaseOptionIn';

const includedPurchaseOptions = ['product-and-install', 'product-only'];

export default (allItems, design) => flow(
  getItemsWithPurchaseOptionIn(includedPurchaseOptions, design.designId),
  size,
)(allItems);
